import { render, staticRenderFns } from "./BannerMtLink.vue?vue&type=template&id=09333bc1&scoped=true&"
import script from "./BannerMtLink.vue?vue&type=script&lang=js&"
export * from "./BannerMtLink.vue?vue&type=script&lang=js&"
import style0 from "./BannerMtLink.vue?vue&type=style&index=0&id=09333bc1&lang=scss&scoped=true&"
import style1 from "./BannerMtLink.vue?vue&type=style&index=1&id=09333bc1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09333bc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09333bc1')) {
      api.createRecord('09333bc1', component.options)
    } else {
      api.reload('09333bc1', component.options)
    }
    module.hot.accept("./BannerMtLink.vue?vue&type=template&id=09333bc1&scoped=true&", function () {
      api.rerender('09333bc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/BannerMtLink/components/desktop/BannerMtLink.vue"
export default component.exports